module.exports = __webpack_public_path__ + "img/personal-info.4c617c99.svg";